import type { ComponentPropsWithRef } from 'react'
import { cn } from '../../lib/cn'
import s from './Textarea.module.css'

/**
 * Zone de saisie multiligne — le `.ta` du prototype : les observations libres de l'agent,
 * le motif d'un rendez-vous, un commentaire de validation.
 *
 * Un `<textarea>` natif sans primitive : la plateforme fournit déjà le rôle, le focus, le
 * clavier et le redimensionnement. Il n'y a donc pas de conteneur porteur de bordure, et
 * pas besoin du mixin `field-focus` — l'anneau de `base.css` entoure directement l'élément
 * focalisé, ce qui est exactement le rendu voulu.
 *
 * `onValueChange` en plus de `onChange`, comme `Input` : un écran qui range du texte dans un
 * état n'a pas à connaître l'objet d'événement.
 */
export interface TextareaProps extends ComponentPropsWithRef<'textarea'> {
  /** La valeur saisie, sans passer par l'événement. */
  onValueChange?: (value: string) => void
}

export function Textarea({ className, onChange, onValueChange, ...props }: TextareaProps) {
  return (
    <textarea
      className={cn(s.root, className)}
      onChange={(event) => {
        onChange?.(event)
        onValueChange?.(event.currentTarget.value)
      }}
      {...props}
    />
  )
}
